<ng-template #formTmpl>
    <div class="form-container">
        <div class="form-group-container" [class.progressStepContainer]="progressStepIndicator">
            <h3 *ngIf="!isInModalDialog" class="form-headline">{{headerTitle}}</h3>
            <common-form-progress-step *ngIf="progressStepIndicator" [step]="progressStep" [maxSteps]="progressMaxSteps"
                                        [stepNames]="progressStepNames"></common-form-progress-step>
            <form>
                <common-form-buttons *ngIf="placeBtnAtTop && buttons"
                                        [ngClass]="placeIconsAtTop ? 'iconsAtTop' : 'noIconsAtTop'">
                    <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                </common-form-buttons>
                <div *ngIf="placeIconsAtTop && icons" class="controlWrapper withIcons chPadding">
                    <div class="genericControl">
                        <ng-template [ngTemplateOutlet]="icons"></ng-template>
                    </div>
                </div>
                <ng-content></ng-content>
                <div *ngIf="requiredFieldsHint" class="required-fields-hint">
                    <div class="">{{i18n.formFieldComponent.globalMessages.requiredFieldsHint}}</div>
                </div>
                <div *ngIf="placeIconsAtBottom && icons"
                        class="controlWrapper withIcons {{placeBtnAtBottom ? 'chPadding' : ''}}">
                    <div class="genericControl">
                        <ng-template [ngTemplateOutlet]="icons"></ng-template>
                    </div>
                </div>
                <common-form-buttons *ngIf="placeBtnAtBottom && buttons"
                                        [ngClass]="placeIconsAtBottom ? 'iconsAtBottom' : ''">
                    <ng-template [ngTemplateOutlet]="buttons"></ng-template>
                </common-form-buttons>
            </form>
        </div>
    </div>
</ng-template>

<!-- Formular ohne eigene Box. -->
<div *ngIf="!showBox" class="formGroup">
    <ng-container *ngTemplateOutlet="formTmpl"></ng-container>
</div>

<!-- Formular mit eigener Box und Info-Box.
    Die Klasse formBox sorgt u.a. dafür, dass sich die Info-Box bei kleineren Breiten über die Formular-Box stapelt. -->
<div *ngIf="showBox" class="formBox">
    <div class="box {{boxSize}} formGroup">
        <div class="innerBox">
            <ng-container *ngTemplateOutlet="formTmpl"></ng-container>
        </div>
    </div>
    <ng-content select="[box-half]"></ng-content>
    <div class="box one formInfo" *ngIf="infoBoxTitle && infoBoxText">
        <div class="innerBox">
            <div class="form-container">
                <div class="form-info-group">
                    <h3 class="form-headline">{{infoBoxTitle}}</h3>
                    <aside class="form-group">
                        <p [innerHTML]="infoBoxText"></p>
                    </aside>
                </div>
            </div>
        </div>
    </div>
</div>
